import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, Grid, LL_H_C, LL_V_L, openContent, SimpleListAdapter, TS_DropDown, TS_PropRenderer, TS_Tabs, TS_Toggle } from '@nu-art/thunderstorm-frontend/index';
import { findingRenderMethod_Flat, findingRenderMethod_LabelMap, findingSortMethod_LabelMap, findingSortMethod_Static, findingViewSection_ConfigInfoMap, findingViewSection_ConfigLabelMap, findingViewSection_TypeLabelMap, findingViewSectionType_ByOrder, findingViewSectionType_FishBone, findingViewSectionType_Flat, findingViewSectionType_Graph, } from '@app/advisor-ui-shared';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { DefaultEditor_InputText, DefaultEditor_InputText_Optional } from '@app/styles/frontend/ui-manager/ui-components';
import { DropDown_FindingViewSectionType } from '../ui-components.js';
import { DropDown_ContextRule, DropDown_Values, DropDown_Variable, ModuleFE_ContextRule, ModuleFE_MeasurementUnit, ModuleFE_Value, ModuleFE_Variable, MultiSelect_Variable } from '@app/hcs-frontend';
import { _keys, exists } from '@nu-art/ts-common';
import { ICONS } from '@app/styles';
import './Editor_FindingViewSection.scss';
import { DropDown_FindingRenderMethod } from '../../finding-render-method/ui-components.js';
import { DropDown_FindingSortMethod } from '../../finding-sort-method/ui-components.js';
import { ConfigKeyFE_Fishbone_Defaults } from '../../fishbone/index.js';
import { Renderer_FishBone, Renderer_SectionGraph } from '../../../index.js';
import { mockFishboneResults } from '../../../ui/Renderer_FishBone/utils/mock-results.js';
import { mockSectionGraphResults } from '../../../ui/Renderer_SectionGraph/utils/mock-results.js';
const viewMode_View = 'view';
const viewMode_Edit = 'edit';
export class Editor_FindingViewSection extends ComponentSync {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable = nextProps.editable;
        state.editMode = nextProps.editMode;
        return state;
    }
    // ######################## Logic ########################
    getViewMode = () => this.state.editMode ? viewMode_Edit : viewMode_View;
    getTabs = () => {
        const section = this.state.editable.item;
        const tabs = [];
        //Always push the general tab
        tabs.push({ uid: 'general', title: 'General', content: this.renderTab_General });
        switch (section.type) {
            case findingViewSectionType_Flat:
            case findingViewSectionType_ByOrder:
                tabs.push({ uid: 'data', title: 'Data', content: this.renderEditor_Data_Flat });
                break;
            case findingViewSectionType_FishBone:
                tabs.push({ uid: 'data', title: 'Data', content: this.renderEditor_Data_Fishbone });
                break;
            case findingViewSectionType_Graph:
                tabs.push({ uid: 'data', title: 'Data', content: this.renderEditor_Data_Graph });
                break;
        }
        return tabs;
    };
    getDataForType = (section, nextType) => {
        //No need to switch data if switching between flat and by-order
        if ([findingViewSectionType_Flat, findingViewSectionType_ByOrder].includes(section.type) && [findingViewSectionType_Flat,
            findingViewSectionType_ByOrder].includes(nextType))
            return section.data;
        switch (nextType) {
            case findingViewSectionType_Flat:
            case findingViewSectionType_ByOrder:
                return {
                    findingSortMethod: findingSortMethod_Static,
                    findingRenderMethod: findingRenderMethod_Flat,
                };
            case findingViewSectionType_FishBone:
                return {};
            case findingViewSectionType_Graph:
                return { variableIds: [] };
        }
    };
    // ######################## Render ########################
    render() {
        const tabs = this.getTabs();
        return _jsx(TS_Tabs, { className: 'editor__finding-view-section', tabs: tabs });
    }
    // ######################## Render - General Tab ########################
    renderTab_General = () => {
        return _jsxs(_Fragment, { children: [this.renderEditor_Label(), this.renderEditor_Type(), this.renderEditor_Config()] });
    };
    renderEditor_Label = () => {
        const editable = this.state.editable;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Label', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: viewMode_View,
                        renderer: () => _jsx("div", { className: 'editor__finding-view__value', children: editable.item.label })
                    },
                    { key: viewMode_Edit, renderer: () => _jsx(DefaultEditor_InputText, { editable: editable, prop: 'label' }) }
                ] }) });
    };
    renderEditor_Type = () => {
        const editable = this.state.editable;
        const type = editable.item.type ? findingViewSection_TypeLabelMap[editable.item.type] : 'N/A';
        return _jsx(TS_PropRenderer.Vertical, { label: 'Section Type', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__finding-view__value', children: type }) },
                    {
                        key: viewMode_Edit,
                        renderer: () => _jsx(DropDown_FindingViewSectionType.selectable, { canUnselect: false, selected: editable.item.type, onSelected: type => {
                                if (editable.item.type === type)
                                    return;
                                const data = this.getDataForType(editable.item, type);
                                // @ts-ignore
                                editable.updateObj({ type, data });
                            } })
                    }
                ] }) });
    };
    renderEditor_Config = () => {
        const editable = this.state.editable.editProp('config', {});
        return _jsx(TS_PropRenderer.Vertical, { label: 'Config', children: _jsx(Grid, { className: 'editor__finding-view-section__configs', children: _keys(findingViewSection_ConfigLabelMap).map(key => {
                    const checked = !!editable.item[key];
                    return _jsxs(LL_H_C, { className: 'editor__finding-view-section__config', children: [_jsx("div", { className: 'editor__finding-view-section__config__label', children: findingViewSection_ConfigLabelMap[key] }), _jsx(ICONS.information.component, { ...openContent.tooltip.top('finding-view-section-config-tooltip', findingViewSection_ConfigInfoMap[key], { offset: 10 }) }), _jsx(TS_Toggle, { checked: !!editable.item[key], onCheck: () => {
                                    editable.updateObj({ [key]: !checked });
                                }, disabled: !this.state.editMode })] }, key);
                }) }) });
    };
    // ######################## Render - Data Tab - Flat ########################
    renderEditor_Data_Flat = () => {
        return _jsx(LL_V_L, { className: 'editor__finding-view-section__data-flat', children: _jsxs(LL_H_C, { children: [this.renderEditor_Data_Flat_FindingRenderMethod(), this.renderEditor_Data_Flat_FindingSortMethod(), this.renderEditor_Data_Flat_ContextRules(), this.renderEditor_Data_ByOrder_OrderContextRule()] }) });
    };
    renderEditor_Data_Flat_ContextRules = () => {
        const contextRule = ModuleFE_ContextRule.cache.unique(this.state.editable.item.data?.contextRuleId);
        const editableData = this.state.editable.editProp('data', {});
        return _jsx(TS_PropRenderer.Horizontal, { label: 'Rules', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: viewMode_View,
                        renderer: () => _jsx("div", { className: 'editor__finding-view__value', children: contextRule?.label ?? '-' })
                    },
                    {
                        key: viewMode_Edit,
                        renderer: () => _jsx(DropDown_ContextRule.editable, { disabled: !this.state.editMode, editable: editableData, prop: 'contextRuleId' })
                    }
                ] }) });
    };
    renderEditor_Data_ByOrder_OrderContextRule = () => {
        if (this.state.editable.item.type !== findingViewSectionType_ByOrder)
            return;
        const contextRule = ModuleFE_ContextRule.cache.unique(this.state.editable.item.data?.orderContextRuleId);
        const editableData = this.state.editable.editProp('data', {});
        return _jsx(TS_PropRenderer.Horizontal, { label: 'Order Rule', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: viewMode_View,
                        renderer: () => _jsx("div", { className: 'editor__finding-view__value', children: contextRule?.label ?? '-' })
                    },
                    {
                        key: viewMode_Edit,
                        renderer: () => _jsx(DropDown_ContextRule.editable, { canUnselect: true, disabled: !this.state.editMode, editable: editableData, prop: 'orderContextRuleId' })
                    }
                ] }) });
    };
    renderEditor_Data_Flat_FindingRenderMethod = () => {
        const section = this.state.editable;
        const editable = section.editProp('data', {});
        const method = editable.item.findingRenderMethod ? findingRenderMethod_LabelMap[editable.item.findingRenderMethod] : 'N/A';
        return _jsx(TS_PropRenderer.Horizontal, { label: 'Finding Render Method', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__finding-view__value', children: method }) },
                    {
                        key: viewMode_Edit,
                        renderer: () => _jsx(DropDown_FindingRenderMethod.editable, { editable: editable, prop: 'findingRenderMethod', canUnselect: false })
                    }
                ] }) });
    };
    renderEditor_Data_Flat_FindingSortMethod = () => {
        const section = this.state.editable;
        const editable = section.editProp('data', {});
        const method = editable.item.findingSortMethod ? findingSortMethod_LabelMap[editable.item.findingSortMethod] : 'N/A';
        return _jsx(TS_PropRenderer.Horizontal, { label: 'Finding Sort Method', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__finding-view__value', children: method }) },
                    {
                        key: viewMode_Edit,
                        renderer: () => _jsx(DropDown_FindingSortMethod.editable, { editable: editable, prop: 'findingSortMethod', canUnselect: false })
                    }
                ] }) });
    };
    // ######################## Render - Data Tab - Fishbone ########################
    renderEditor_Data_Fishbone = () => {
        const section = this.state.editable;
        const data = section.editProp('data', {});
        return _jsxs(_Fragment, { children: [this.renderEditor_Data_Fishbone_Dropdown(data), this.renderEditor_Data_Fishbone_Preview(data)] });
    };
    renderEditor_Data_Fishbone_Dropdown = (data) => {
        const selected = data.item.fishbone;
        return _jsx(TS_PropRenderer.Vertical, { label: 'FishBone structure', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: viewMode_View,
                        renderer: () => _jsx("div", { className: 'editor__finding-view__value', children: selected?.label ?? 'N/A' })
                    },
                    {
                        key: viewMode_Edit,
                        renderer: () => {
                            const defaults = ConfigKeyFE_Fishbone_Defaults.get();
                            const adapter = SimpleListAdapter(defaults, item => _jsx(_Fragment, { children: item.item.label }));
                            return _jsx(TS_DropDown, { adapter: adapter, onSelected: fishbone => {
                                    this.logInfo(fishbone);
                                    data.updateObj({ fishbone: fishbone });
                                }, selected: selected });
                        }
                    }
                ] }) });
    };
    renderEditor_Data_Fishbone_Preview = (data) => {
        const struct = data.item.fishbone;
        if (!struct)
            return;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Preview', children: _jsx("div", { className: 'renderer__fish-bone--preview', children: _jsx(Renderer_FishBone, { struct: struct, results: mockFishboneResults(struct), modules: {
                        variable: ModuleFE_Variable,
                        value: ModuleFE_Value,
                        measurementUnit: ModuleFE_MeasurementUnit,
                    } }) }) });
    };
    // ######################## Render - Data Tab - Graph ########################
    renderEditor_Data_Graph = () => {
        const section = this.state.editable;
        const data = section.editProp('data', {});
        return _jsxs(LL_H_C, { className: 'editor__finding-view-section__data-graph', children: [this.renderEditor_Data_Graph_Variables(data), this.renderEditor_Data_Graph_Abbreviation(data), this.renderEditor_Data_Graph_Preview(data), this.renderEditor_Data_Graph_Alert(data)] });
    };
    renderEditor_Data_Graph_Abbreviation = (data) => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Abbreviation', children: _jsx(DefaultEditor_InputText_Optional, { editable: data, prop: 'abbreviation' }) });
    };
    renderEditor_Data_Graph_Variables = (data) => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Variables', children: _jsx(MultiSelect_Variable, { editable: data, prop: 'variableIds', disabled: !this.state.editMode }) });
    };
    renderEditor_Data_Graph_Alert = (data) => {
        const editable = data.editProp('alert', {});
        editable.setDeleteAction(() => data.updateObj({ alert: undefined }));
        const variable = ModuleFE_Variable.cache.unique(editable.item.variableId);
        return _jsxs(TS_PropRenderer.Vertical, { label: 'Alert', children: [_jsx(TS_PropRenderer.Vertical, { label: 'Alert Variable', children: _jsx(DropDown_Variable, { canUnselect: true, selected: editable.item.variableId, disabled: !this.state.editMode, onSelected: variable => {
                            if (variable?._id === editable.item.variableId)
                                return;
                            if (!variable)
                                return editable.delete();
                            data.updateObj({ alert: { variableId: variable._id, normalValueId: undefined } });
                        } }) }), exists(variable) && _jsx(TS_PropRenderer.Vertical, { label: 'Normal Value', children: _jsx(DropDown_Values, { canUnselect: true, disabled: !this.state.editMode, variable: variable, selected: editable.item.normalValueId, onSelected: value => {
                            editable.updateObj({ normalValueId: value?._id });
                        } }) })] });
    };
    renderEditor_Data_Graph_Preview = (data) => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Preview', children: _jsx(Renderer_SectionGraph, { results: mockSectionGraphResults(data.item.variableIds ?? []), variableOrder: data.item.variableIds ?? [] }) });
    };
}
//# sourceMappingURL=Editor_FindingViewSection.js.map